function QuoteRequestForm($form) {
  var $errorsAlert = $('.alert-danger', $form);
  var $errorsContainer = $('.errors', $errorsAlert);
  var $successAlert = $('.alert-success', $form);
  var errorClass = 'has-error';
  
  // Reset everything
  this.reset = function() {
    hideErrors();
    unhighlightErrors();
    hideSuccess();
    $form.get(0).reset();
    
    return this;
  };
  
  // Allows setting the product ID from outside
  this.setProductId = function(productId) {
    $('[name="productId"]').val(productId);
    
    return this;
  };
  
  function resetErrors() {
    $errorsContainer.empty();
    unhighlightErrors();
  }
  
  function showErrors(errors) {
    var $ul = $('<ul>');
    
    var list = '';
    $.each(errors, function(field, messages) {
      list += '<li>' + messages.join('</li><li>') + '</li>';
    });
    
    $ul.html(list);
    $errorsContainer.html($ul);
    $errorsAlert.show();
  };
  
  function highlightErrors(errors) {
    unhighlightErrors();
    
    $.each(errors, function(field, messages) {
      $('[name="' + field + '"]', $form).parents('.form-group').addClass(errorClass);
    });
  }
  
  function unhighlightErrors() {
	$('.form-group', $form).removeClass(errorClass);
  }
  
  function hideErrors() {
    $errorsAlert.hide();
  }
  
  function showGeneralError(errorText) {
    if (typeof errorText == 'undefined') {
      errorText = '<p>A apărut o eroare la noi la trimiterea formularului.</p>'
        + '<p>Te rugăm să ne contactezi la 0722 640 295 în programul:<br>L-V: 8.00 - 18.00<br>S: 9.00 - 14.00.</p>'
        + '<p>Îți mulțumim pentru înțelegere.</p>';
    } else {
      errorText = '<ul><li>' + errorText.join('</li><li>') + '</li></ul>';
    }
    
	$errorsContainer.html(errorText);
    $errorsAlert.show();
    unhighlightErrors();
  }
  
  function showSuccess() {
    $successAlert.show();
  }
  
  function hideSuccess() {
    $successAlert.hide();
  }
  
  $form.submit(function(e) {
    e.preventDefault();

    var $submitButton = $('button[type=submit]', $form);
    $submitButton.addClass('disabled');
    
    $.post('https://fire.semineeas.ro/quotes', $form.serialize(), function(data) {
      hideErrors();
      unhighlightErrors();
      showSuccess();
      $form.get(0).reset();
    }).fail(function(data) {      
      try {
        var responseJson = $.parseJSON(data.responseText);
        var messages = typeof responseJson.messages != 'undefined' ?
          responseJson.messages : null;
        
        hideSuccess();
        
        if ($.isPlainObject(messages)) {
          showErrors(messages);
          highlightErrors(messages);
        } else if ($.isArray(messages)) {
		  showGeneralError(messages);
        } else {
          showGeneralError();
        }
      } catch (e) {
        showGeneralError();
      }
    }).always(function() {
      $submitButton.removeClass('disabled');
    });
  });
}